// extracted by mini-css-extract-plugin
module.exports = {"blueDark":"#293846"};